/*
*
* Constants
*
*/
export const SIGNUP_FORM_SUBMIT = 'src/components/Features/public/SIGNUP_FORM_SUBMIT';